/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationSettingsDataSchema = z.object({
	invoicingEnabled: z.boolean().nullable().optional(),
	externalInvoicing: z.boolean().nullable().optional(),
	isDemo: z.boolean().nullable().optional(),
	careerSiteEnabled: z.boolean().nullable().optional(),
})

export type UpdateOrganisationSettingsDataSchema = z.infer<typeof updateOrganisationSettingsDataSchema>
